module.exports = __webpack_public_path__ + "static/media/visaimg.97666ef1.png";